import { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Typography, Stack, Box, CircularProgress,
} from '@mui/material';
import { CREDENTIAL_PROVIDERS } from '../../Pages/Homepage/Helper';



function CredentialDialog({ open, onClose, onSubmit, provider }) {
  const config = CREDENTIAL_PROVIDERS[provider];
  const [values, setValues]   = useState({});
  const [loading, setLoading] = useState(false);

  if (!config) return null;

  const handleChange = (key, val) => setValues(prev => ({ ...prev, [key]: val }));

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit?.(values);
    setLoading(false);
    onClose();
  };

  const isComplete = config.fields.every(f => values[f.key]?.trim());

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 15, fontWeight: 500, pb: 0.5 }}>
        Connect {provider}
      </DialogTitle>

      <DialogContent sx={{ pt: '12px !important' }}>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          Enter your {provider} credentials to enable this integration.
        </Typography>

        <Stack spacing={2}>
          {config.fields.map(field => (
            <TextField
              key={field.key}
              label={field.label}
              type={field.type}
              placeholder={field.placeholder}
              size="small"
              fullWidth
              value={values[field.key] || ''}
              onChange={e => handleChange(field.key, e.target.value)}
              slotProps={field.type === 'password' ? { input: { autoComplete: 'new-password' } } : {}}
            />
          ))}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button size="small" color="inherit" onClick={onClose}>Cancel</Button>
        <Button
          size="small"
          variant="contained"
          disabled={!isComplete || loading}
          onClick={handleSubmit}
          startIcon={loading ? <CircularProgress size={12} color="inherit" /> : null}
        >
          {loading ? 'Connecting...' : 'Connect'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CredentialDialog;